import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@fortawesome/free-solid-svg-icons';
import styled, { css } from 'styled-components';
import { v2Colors, v2FontFamily, v2Breakpoints } from '../../formInputsV2/styles/tokens';

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 16px;
  background: linear-gradient(135deg, #e8f5e9 0%, #b9f6ca 100%);
  border-radius: 8px;
  border: 1px solid #a5d6a7;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
  width: 100%;
  margin-bottom: 20px;

  ${(p) => p.$v2 && css`
    gap: 24px;
    border: 1px solid ${v2Colors.primaryBorder};
    border-radius: 14px;
    background: ${v2Colors.primarySoft};
    box-shadow: none;
    font-family: ${v2FontFamily};

    @media (max-width: ${v2Breakpoints.tablet}) {
      flex-direction: column;
      align-items: stretch;
    }
  `}

  /* phones: stack the banner; icon + title on one line, the description under them, button full width */
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;

    .customer-link-info {
      flex-wrap: wrap;
      justify-content: flex-start !important;
      row-gap: 6px;

      > span:last-child {
        flex-basis: 100%;
        margin-left: 0 !important;
      }
    }

    button {
      width: 100%;
    }
  }
`;

const Title = styled.span`
    color: #2c3e50;
    font-size: 14px;
    font-weight: 500;
    margin: 0;
    line-height: 1.4;
    white-space: nowrap;

    ${(p) => p.$v2 && css`
      font-family: ${v2FontFamily};
      font-weight: 700;
      color: ${v2Colors.text};
    `}
`;

const InfoIcon = styled.div`
    width: 24px;
    height: 24px;
    background: linear-gradient(135deg, #2196f3 0%, #1976d2 100%);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-size: 14px;
    flex-shrink: 0;

    ${(p) => p.$v2 && css`
      width: 32px;
      height: 32px;
      border-radius: 10px;
      background: ${v2Colors.primary};
    `}
`;

const LinkButton = styled.button`
    background: linear-gradient(135deg, #4CAF50 0%, #45a049 100%);
    color: white;
    border: none;
    padding: 8px 16px;
    font-size: 14px;
    font-weight: 500;
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.2s ease;
    box-shadow: 0 1px 4px rgba(76, 175, 80, 0.2);
    min-width: 100px;
    white-space: nowrap;

    &:hover {
        background: linear-gradient(135deg, #45a049 0%, #3d8b40 100%);
        transform: translateY(-1px);
        box-shadow: 0 2px 6px rgba(76, 175, 80, 0.3);
    }

    &:active {
        transform: translateY(0);
        box-shadow: 0 1px 2px rgba(76, 175, 80, 0.3);
    }

    &:disabled {
        background: #cccccc;
        cursor: not-allowed;
        transform: none;
        box-shadow: none;
    }

    ${(p) => p.$v2 && css`
      padding: 9px 18px;
      border-radius: 999px;
      background: ${v2Colors.primary};
      box-shadow: none;
      font-family: ${v2FontFamily};
      font-weight: 700;

      &:hover {
        background: ${v2Colors.primaryHover};
        transform: none;
        box-shadow: 0 4px 10px rgba(0, 166, 81, 0.25);
      }

      &:disabled {
        background: #cccccc;
      }
    `}
`;

function CompletedScreenCustomerLinkButton({
  onNavigate, buttonText = 'Apri dettaglio cliente', disabled = false, v2 = false,
}) {
  return (
    <Container $v2={v2}>
      <div className="d-flex align-items-center justify-content-center gap-2 customer-link-info">
        <InfoIcon $v2={v2}>
          <FontAwesomeIcon icon={faUser} style={{ fontSize: 14 }} />
        </InfoIcon>
        <Title $v2={v2}>{buttonText}</Title>
        <span style={{ fontSize: '0.95rem', color: '#555', marginLeft: 8 }}>
          Visualizza i dettagli cliente collegati a questa quotazione.
        </span>
      </div>
      <LinkButton
        $v2={v2}
        onClick={onNavigate}
        type="button"
        disabled={disabled}
      >
        Anagrafica Cliente
      </LinkButton>
    </Container>
  );
}

export default CompletedScreenCustomerLinkButton;
